import React, { useContext, useEffect, useState } from 'react'
import cn from 'classnames'
import styles from './Bid.module.sass'
import { getContracts } from '../../adapters/eth'
import Loader from '../Loader'
import { fromWei } from 'web3-utils'
import { Web3Context } from '../../contexts/Web3Context'
import { message } from 'antd'
import ShortenAddress from '../ShortenAddress'
import Balance from '../Balance'
import LoaderCircle from '../LoaderCircle'
import Icon from '../Icon'
import config from '../../config'

message.config({ top: 100, duration: 5, maxCount: 3 })

const Bid = ({ className, token, users }) => {

  const [creator, setCreator] = useState()
  const [contracts, setContracts] = useState()
  const [processBuy, setProcessBuy] = useState(false)
  const [isPutted, setPutted] = useState(false)

  const { web3, isConnected, isCorrectNetwork, defaultAccount } = useContext(Web3Context)

  useEffect(() => {
    if (token) {
      const createUser = users[token.currentOwner] ?? token.currentOwner
      setCreator(createUser);

      (async () => {
        const contr = await getContracts(web3)
        setContracts(contr)

        if (token.ether_price == null) {
          token.ether_price = fromWei(token.price, 'ether')
        }
      })()
    }

  }, [token, users, web3, defaultAccount])

  const buyIt = async (event) => {
    event.preventDefault()

    setProcessBuy(true)
    try {
      contracts.Marketplace.methods.buy(token.in_sale).send({ from: defaultAccount, value: token.price }).once('receipt', () => {
        setProcessBuy(false)
        setPutted(true)
        message.success('Token bought')
      }).on('error', error => {
        console.error(error)
        message.error('Error on buy')
        setProcessBuy(false)
        return false
      })
    } catch (error) {
      console.error(error)
      message.error('Error on buy')
      setProcessBuy(false)
      return false
    }
  }

  const closeIt = () => {
    window.location.href = '/profile'
  }

  return (
    <div className={cn(className, styles.checkout)}>
      <div className={cn('h4', styles.title)}>Buy</div>
      <div className={styles.info}>
        You are about to purchase <strong>{token.name}</strong> from{' '}
        {creator && <strong>{creator.username ?? <ShortenAddress address={creator}/>}</strong>}
      </div>
      <div className={styles.table}>
        <div className={styles.row}>
          <div className={styles.col}>Item price</div>
          <div className={styles.col}>{token.ether_price || fromWei(token.price, 'ether')}&nbsp;{config.symbolName}</div>
        </div>
        <div className={styles.row}>
          <div className={styles.col}>Your balance</div>
          <div className={styles.col}><Balance/></div>
        </div>
      </div>
      <div className={styles.btns}>
        {isConnected && isCorrectNetwork && <div className={cn(styles.item, { [styles.done]: isPutted })}>
          <div className={styles.head}>
            <div className={styles.icon}>
              {processBuy ?
                <LoaderCircle className={styles.loader}/> :
                <Icon name="pencil" size="24"/>
              }
            </div>
            <div className={styles.details}>
              <div className={styles.info}>Buy</div>
              <div className={styles.text}>
                Buy token using your wallet
              </div>
            </div>
          </div>
          <button
            className={cn('button', styles.button, { ['loading']: processBuy }, { ['done']: isPutted })}
            onClick={buyIt}>
            {!isPutted ? (processBuy ?
              <Loader className={styles.loader} color="white"/> : 'Buy') : 'Done'}
          </button>
        </div>
        }
        {isPutted &&
          <div className={cn(styles.item, styles.done)}>
            <div className={styles.head}>
              <div className={styles.icon}>
                <Icon name="bag" size="24"/>
              </div>
              <div className={styles.details}>
                <div className={styles.info}>All is done!</div>
                <div className={styles.text}>
                  You successfully bought token
                </div>
              </div>
            </div>
            <button className={cn('button', styles.button)} onClick={closeIt}>Close</button>
          </div>
        }
      </div>
    </div>
  )
}

export default Bid
